import React from 'react';
import { Form } from 'react-router-dom';
import appointment from '../../../assets/images/appointment.png'

const Contactus = () => {

    return (
        <div>

            <div className="">
                <div className="hero "style={{
            background:`url(${appointment})`
        }}>

                    <div className="hero-content flex-col lg:flex-row-reverse">
                        <div className="text-center">
                        </div>
                        <div className="card flex-shrink-0 w-full   text-center p-10">
                            <h1 className='text-info lg:text-2xl font-semibold'>Contact Us</h1>
                            <h2 className='lg:text-3xl font-semibold text-white'> Stay connected with us</h2>
                            <div className="card-body">
                            <div className="form-control">
                                    <label className="label">
                                        <input type="email" placeholder="Email" className="input input-bordered w-full" />
                                    </label>
                                </div>
                                <div className="form-control">
                                    <label className="label">
                                        <input type="text" placeholder="Subject" className="input input-bordered w-full" />
                                    </label>
                                </div>
                                <div className="form-control">
                                    <label className="label">
                                        <textarea placeholder="Your Message" className="textarea textarea-bordered textarea-lg w-full max-w-xs" ></textarea>
                                    </label>
                                </div>
                                <div className="form-control mt-6">
                                    <button className="btn btn-info text-white">Submit</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div>
    );
};

export default Contactus;